import { HttpClient } from '@angular/common/http'
import { Environment } from '@fabrik/common'
import { Observable } from 'rxjs'
import { TenantAgent } from '../models/TenantAgent'

export class AgentCustomizationDataService {
    constructor(private environment: Environment, private http: HttpClient) {}

    get(tenantId: string): Observable<TenantAgent> {
        return this.http.get<TenantAgent>(`${this.environment.appApiHost}/api/${tenantId}/admin/tenantagent`)
    }

    create(tenantId: string, payload: TenantAgent): Observable<TenantAgent> {
        return this.http.post<TenantAgent>(`${this.environment.appApiHost}/api/${tenantId}/admin/tenantagent`, payload)
    }

    update(tenantId: string, payload: TenantAgent): Observable<TenantAgent> {
        return this.http.put<TenantAgent>(`${this.environment.appApiHost}/api/${tenantId}/admin/tenantagent`, payload)
    }

    delete(tenantId: string): Observable<void> {
        return this.http.delete<void>(`${this.environment.appApiHost}/api/${tenantId}/admin/tenantagent`)
    }
}

